import { THIS_WEEK, COMPLETED } from "Constants/stringConstants";

export const CLASS_STREAM_TASKS = "CLASS_STREAM_TASKS";

export const NAME = "todos";
export const UPDATE_FILTERS_OBJECT = "UPDATE_FILTERS_OBJECT" + " " + NAME;
export const UPDATE_TODOS_COUNT = "UPDATE_TODOS_COUNT" + " " + NAME;

export const HEADER_TABS_ARR_V2 = [
  {
    value: "TODO",
    label: "classRoom:todo",
  },
  {
    value: "NOT_SUBMITTED",
    label: "classRoom:not_submitted",
  },
  {
    value: COMPLETED, // This constant is connected with NavigationModule type TODO for email redirection
    label: "common:done",
  },
];

export const TABS_LABEL_MAPPING = {
  THIS_WEEK: {
    label: "classRoom:this_week",
  },
  LAST_WEEK: {
    label: "classRoom:last_week",
  },
  EARLIER: {
    label: "classRoom:earlier",
  },
  NODUE: {
    label: "classRoom:no_due_date",
  },
  OVERDUE: {
    label: "classRoom:overdue",
  },
  UPCOMING: {
    label: "common:upcoming",
  },
  NOT_SUBMITTED: {
    label: "classRoom:not_submitted",
  },
  SCHEDULED: {
    label: "common:scheduled",
  },
};

export const HEADER_TABS_EMPTY_STATE_MSG_MAPPING = {
  UPCOMING: {
    emptyMsg: "classRoom:upcoming_maintext",
    emptySubMsgParent: "classRoom:upcoming_family_subtext",
    emptySubMsg: "classRoom:upcoming_subtext",
  },
  NODUE: {
    emptyMsg: "classRoom:nothing_here_yet",
    emptySubMsgParent: "classRoom:nodue_subtext",
    emptySubMsg: "classRoom:nodue_subtext",
  },
  OVERDUE: {
    emptyMsg: "classRoom:no_overdue_maintext",
    emptySubMsgParent: "classRoom:overdue_family_subtext",
    emptySubMsg: "classRoom:overdue_subtext",
  },
  THIS_WEEK: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  LAST_WEEK: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  EARLIER: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  NOT_SUBMITTED: {
    emptyMsg: "classRoom:not_submitted_empty_state_title",
    emptySubMsgParent: "classRoom:not_submitted_empty_state_subtitle",
    emptySubMsg: "classRoom:not_submitted_empty_state_subtitle",
  },
};

export const HEADER_TABS_EMPTY_STATE_MSG_MAPPING_V2 = {
  UPCOMING: {
    next_30: {
      emptyMsg: "classRoom:all_assignments_done_for_next_30_days_have_overdue",
      emptySubMsgParent:
        "classRoom:successfully_completed_all_upcoming_assignments_and_deadlines",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    next_30_have_overdue: {
      emptyMsg: "classRoom:all_done_for_next_30_days_have_overdue",
      emptySubMsgParent:
        "classRoom:successfully_completed_all_upcoming_assignments_and_deadlines",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    all_done: {
      emptyMsg: "classRoom:you_are_all_done",
      emptySubMsgParent:
        "classRoom:successfully_completed_all_upcoming_assignments_and_deadlines",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    no_upcoming_have_overdue: {
      emptyMsg: "classRoom:todo_no_upcoming_assignments_have_overdue",
      emptySubMsgParent:
        "classRoom:successfully_completed_all_upcoming_assignments_and_deadlines",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    no_upcoming_have_overdue_todo_page: {
      emptyMsg: "classRoom:todo_no_upcoming_assignments",
      emptySubMsgParent: "classRoom:check_for_overdue",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
  },
  NODUE: {
    emptyMsg: "classRoom:you_all_caught_up",
    emptySubMsgParent: "classRoom:empty",
    emptySubMsg: "classRoom:empty",
  },
  OVERDUE: {
    emptyMsg: "classRoom:spotless_assignments_record",
    emptySubMsgParent: "classRoom:no_tasks_overdue",
    emptySubMsg: "classRoom:no_tasks_overdue",
  },
  THIS_WEEK: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  LAST_WEEK: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  EARLIER: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  NOT_SUBMITTED: {
    emptyMsg: "classRoom:not_submitted_empty_state_title",
    emptySubMsgParent: "classRoom:not_submitted_empty_state_subtitle",
    emptySubMsg: "classRoom:not_submitted_empty_state_subtitle",
  },
};

// this mapping is used for parent only
export const HEADER_TABS_EMPTY_STATE_MSG_MAPPING_V3 = {
  UPCOMING: {
    next_30: {
      emptyMsg: "common:empty_upcoming_tasks_msg_with_label",
      emptySubMsgParent: "common:empty_assignments_msg_with_label",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    next_30_have_overdue: {
      emptyMsg: "common:empty_upcoming_assignments_have_overdue_msg_with_label",
      emptySubMsgParent: "common:empty_assignments_msg_with_label",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    all_done: {
      emptyMsg: "common:you_re_all_done_with_label",
      emptySubMsgParent: "common:empty_assignments_msg_with_label",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    no_upcoming_have_overdue: {
      emptyMsg:
        "classRoom:todo_no_upcoming_assignments_have_overdue_with_label",
      emptySubMsgParent:
        "classRoom:successfully_completed_all_upcoming_assignments_and_deadlines",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
    no_upcoming_have_overdue_todo_page: {
      emptyMsg: "classRoom:todo_no_upcoming_assignments",
      emptySubMsgParent: "classRoom:few_are_overdue",
      emptySubMsg: "classRoom:click_on_the_button_below_to_view_more",
    },
  },
  NODUE: {
    emptyMsg: "common:empty_nodue_tasks_msg_with_label",
    emptySubMsgParent: "classRoom:empty",
    emptySubMsg: "classRoom:empty",
  },
  OVERDUE: {
    emptyMsg: "common:empty_overdue_tasks_msg_with_label",
    emptySubMsgParent: "common:empty_overdue_tasks_msg_with_label",
    emptySubMsg: "common:empty_overdue_tasks_msg_with_label",
  },
  THIS_WEEK: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  LAST_WEEK: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  EARLIER: {
    emptyMsg: "common:nothing_here_at_this_moment",
    emptySubMsgParent: "classRoom:completed_todos_subtext_with_label",
    emptySubMsg: "classRoom:completed_todos_subtext_with_label",
  },
  NOT_SUBMITTED: {
    emptyMsg: "classRoom:not_submitted_empty_state_title",
    emptySubMsgParent:
      "classRoom:not_submitted_empty_state_subtitle_with_name_label",
    emptySubMsg: "classRoom:not_submitted_empty_state_subtitle_with_name_label",
  },
};

export const ITEM_TYPE_ARR = [
  { label: "common:assignments", key: "STUDENT_ASSIGNMENT" },
  { label: "project:community_project", key: "COMMUNITY_PROJECT" },
  { label: "project:personal_project", key: "PERSONAL_PROJECT" },
  { label: "project:service_as_action", key: "SERVICE_AS_ACTION" },
];

export const HEADER_BASED_TABS_MAPPING = {
  TODO: ["UPCOMING", "OVERDUE", "NODUE"],
  COMPLETED: [THIS_WEEK, "LAST_WEEK", "EARLIER"], // THIS_WEEK constant is connected with NavigationModule type TODO for email redirection
  NOT_SUBMITTED: ["NOT_SUBMITTED"],
};
